<template>
	<form @submit.prevent="onSubmit">
		<smart-input
			v-show="isNew"
			v-model="form.prefix"
			:error="inputErrors.prefix"
			label="prefix"
		/>
		<projects-select
			v-model="form.project_id"
			:options="projects"
			:error="inputErrors.project_id"
		/>
		<v-select
			v-model="form.type"
			:error="inputErrors.type"
			item-value="id"
			item-text="name"
			label="type"
			:items="couponTypes"
		/>
		<smart-input
			v-model="form.discount"
			:error="inputErrors.discount"
			label="discount"
			type="number"
		/>
		<v-checkbox
			v-model="form.is_one_time"
			label="קופון חד פעמי"
			name="is_one_time"
		/>
		<smart-input
			v-model="form.expire_at"
			:error="inputErrors.expire_at"
			label="expire_at"
			type="datetime-local"
		/>
		<div class="form-group">
			<v-btn
				type="submit"
				:loading="inProgress"
				color="success"
			>
				שמירה
			</v-btn>
		</div>
	</form>
</template>

<script>
import FormView from "src/mixins/FormView";
import CouponModule from "src/store/modules/Coupon.module";
import ProjectsSelect from "@/views/projects/ProjectsSelect";
import { types } from "@/store/modules/Project.module";

export default {
	name: "CouponForm",
	components: { ProjectsSelect },
	mixins: [new FormView(CouponModule, "coupon")],
	props: [],
	data () {
		return {
			form: {
				name: null,
				project_id: null,
				is_one_time: 0,
			},
			couponTypes: [
				{
					name: "fixed",
					id: "fixed",
				},
				{
					name: "percent",
					id: "percent",
				},
			],
		};
	},
	computed: {
		isNew () {
			return !this.coupon.id;
		},
		coupon () {
			const coupon = { ...this.$store.state.CouponModule.coupon };
			coupon.expire_at += "T00:00";
			return coupon;
		},
		projects () {
			return this.$store.state.ProjectModule.projects;
		},
		weekFromNow () {
			const today = new Date();
			return new Date(today.getFullYear(), today.getMonth(), today.getDate() + 7, 0, 0).toISOString().substring(0, 16);
		},
	},
	watch: {
		coupon: function (val) {
			if (val.expire_at.includes("undefined")) {
				this.form.expire_at = this.weekFromNow;
			} else if (val.expire_at) {
				this.form.expire_at = this.form.expire_at.substring(0, 16);
			}
		},
	},
	created () {
		this.$store.dispatch(types.FETCH);
		if (!this.coupon.id) {
			this.form.expire_at = this.weekFromNow;
		} else if (this.form.expire_at) {
			this.form.expire_at = this.form.expire_at.substring(0, 16);
		}
	},
	methods: {
		beforeSubmit () {
			this.form.is_one_time = this.form.is_one_time ? 1 : 0;
		},
	},
};
</script>

<style scoped>

</style>
